import PropTypes from 'prop-types';

const propTypes = {
  classes: PropTypes.shape({
    heading: PropTypes.string,
    formButtons: PropTypes.string,
  }).isRequired,
  userAttributes: PropTypes.shape({
    'custom:buildingLicExp': PropTypes.string,
    'custom:buildingLicNo': PropTypes.string,
    'custom:personalPhone': PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  enableEditing: PropTypes.bool.isRequired,
};

export default propTypes;
